/* global ViewerUI */
/* global $ */

(function (scope) {
  "use strict";

  var PrintViewerView = (scope.PrintViewerView = function (controller, design) {
    this.controller = controller;
    this.design = design;

    //var needed for the viewer to follow the scroll
    this.$viewerContainer = $(".viewer-container");
    this.$document = $(document);
    this.$sidebarContainer = $(".sidebar-container");

    this.$el = $("#PrintViewerView");
    this.$Sculpteo3DViewerWebGL = $(".Sculpteo3DViewerWebGL");
    this.defaultViewerWidth = this.$el.width();
    this.defaultViewerHeight = this.$el.height();
    this.currentViewerWidth = this.defaultViewerWidth;
    this.currentViewerHeight = this.defaultViewerHeight;
    this.minViewerWHeight = 250;
    this.maxViewerWHeight = 0; //set by the css
    this.offsetTopBottom =
      $("#main_menu").outerHeight() +
      $("#PrintToolbarView").height() +
      $("#PrintInformationsView").height() +
      30; // 30 for 3*10px of padding

    this.$el.on(
      "change",
      "#cutaway-settings input[type=range]",
      this.updateCutawayValue.bind(this)
    );
    this.$el.on(
      "input",
      "#cutaway-settings input[type=range]",
      this.updateCutawayValue.bind(this)
    );
    this.$el.on(
      "click",
      ".cutaway-cube div",
      this.updateCutawayAxis.bind(this)
    );

    $(window).on("resize", this.resize.bind(this));

    this.load();

    this.adaptViewerHeight();
  });

  /**
   * Loads viewer and the current design
   */
  PrintViewerView.prototype.load = function () {
    //used for hollowing/thickening
    //load the good model if there is hollowing or thickening
    if (this.design.viewer_file && !this.design.load_original_mesh) {
      delete this.design.viewer_file;
    }
    // Global viewerUI because some code depends on a globally available one (viewer materials)

    this.viewerUI = window.viewerUI = new ViewerUI(
      this.design,
      this.design.viewer_file
    );

    // Overriding some £çè_"è'!!' topics => this was messing up with multiple changes in scale after thickening.
    $.Topic("operation-updated").unsubscribe(
      this.viewerUI.topics["operation-updated"]
    );
    $.Topic("operation-updated").subscribe(
      function (data) {
        this.viewerUI.show_design();
      }.bind(this)
    );

    this.viewerUI.ready();
    //this.viewerUI.launch_viewer();
    this.viewerUI.viewer.setAutorotate(false);
    this.viewerUI.viewer.setZoom(this.viewerUI.viewer.getZoom() + 0.5);

    //set a class to the status message
    this.viewerUI.viewer.setStatusMessage(
      null,
      null,
      null,
      "status-message-container"
    );
  };

  /**
   * adapt the viewer height if the viewer is to small to fit in the current height screen
   * or use the height set in the css as a max height
   */
  PrintViewerView.prototype.adaptViewerHeight = function () {
    // if there is an inline style, remove it
    if (this.$el.attr("style")) {
      this.$el.removeAttr("style");
    }
    // get the height set in css (depends on the media querry)
    this.maxViewerWHeight = this.$el.height();

    // calculate the height of the viewer to fill all the screen with a padding
    var viewerHeight =
      $(window).height() -
      $("#main_menu").outerHeight() -
      $("#PrintToolbarView").outerHeight() -
      $("#PrintInformationsView").outerHeight() -
      30; //padding
    //if the current height of the viewer dont fit in the screen
    if (
      this.$viewerContainer.height() >
      $(window).height() - $("#main_menu").outerHeight()
    ) {
      //check if the viewer height is not smaller than the min
      if (viewerHeight < this.minViewerWHeight) {
        viewerHeight = this.minViewerWHeight;
      }
      //use the calculated height as new heigh
      this.currentViewerHeight = viewerHeight;
    }
    //if the current height viewer fit
    else {
      //check if the viewer is not bigger than the css authorised.
      //use the max as the new height
      if (viewerHeight > this.maxViewerWHeight) {
        viewerHeight = this.maxViewerWHeight;
      }
      //otherwise use the height calculated as new height
      this.currentViewerHeight = viewerHeight;
    }

    //set the new height to the container + update the viewer and canvas
    this.$el.height(this.currentViewerHeight);
    this.$Sculpteo3DViewerWebGL.css({
      height: String(this.currentViewerHeight),
    });
    this.viewerUI.viewer.resize(
      this.$el.outerWidth(),
      String(this.currentViewerHeight)
    );
  };

  /**
   * go to top
   */
  PrintViewerView.prototype.scrollTop = function () {
    this.$document.scrollTop(0);
  };

  /**
   * Handles viewer resize. correct the viewer aftet resizing
   * call adaptViewerHeight to calculated the perfect height
   */
  PrintViewerView.prototype.resize = function () {
    this.adaptViewerHeight();
  };

  /**
   * set reset model position in the viewer
   * @public
   */
  PrintViewerView.prototype.resetModelPosition = function () {
    //this.viewerUI.viewer.resetView();
    this.viewerUI.viewer.animateCamera(
      [1, 0, 0, 0],
      undefined,
      this.viewerUI.viewer.getZoom(),
      400
    );
  };

  /**
   * Toggle wireframe view
   * @public
   * @param {bool} enabled
   */
  PrintViewerView.prototype.toggleWireframe = function (enabled) {
    this.viewerUI.viewer.setWireframe(enabled);
  };

  /**
   * Toggle cutaway view
   * @public
   * @param {bool} enabled
   */
  PrintViewerView.prototype.toggleCutaway = function (enabled) {
    $("#cutaway-settings", this.$el).toggleClass("hidden", !enabled);

    //avoid error when the viewer is not yet ready
    if (this.viewerUI.viewer._getViewerInstance() === undefined) {
      return;
    }

    if (enabled) {
      //fixed issue when there is hollowing activated and the use activate cutaway
      this.controller.views.hollowing.materialUpdated();

      this.cutawayAxis = "X";
      this.cutawayValue = 0.5;
      this.viewerUI.viewer.setCutColor(1.0, 1.0, 1.0, 0.005, 0.267, 0.6, 0.933);
      this.updateCutaway();
    } else {
      this.viewerUI.viewer._getViewerInstance().clrCutColor();
      this.viewerUI.viewer._getViewerInstance().clrCutAxis();
      this.viewerUI.viewer.setLocal(false);
    }
  };

  /**
   * Update cutaway axis after clicking on the cube
   * @private
   * @listens
   */
  PrintViewerView.prototype.updateCutawayAxis = function (event) {
    $(".cutaway-cube div", this.$el).removeClass("selected");
    $(event.currentTarget).addClass("selected");

    this.cutawayAxis = $(event.currentTarget).data("val");
    this.updateCutaway();
  };

  /**
   * Updates cutaway value based on input type range
   * @private
   * @listens
   */
  PrintViewerView.prototype.updateCutawayValue = function (event) {
    this.cutawayValue =
      parseInt($(event.currentTarget).val(), 10) /
      parseInt($(event.currentTarget).prop("max"), 10);
    this.updateCutaway();
  };

  /**
   * Updates cutaway rendering in the viewer
   * @private
   */
  PrintViewerView.prototype.updateCutaway = function () {
    var a, b, c, d;

    switch (this.cutawayAxis) {
      case "X":
        a = 1.0;
        b = 0.0;
        c = 0.0;
        d =
          (this.cutawayValue - 0.5) * this.design.size.x + this.design.center.x;
        break;
      case "Y":
        a = 0.0;
        b = 1.0;
        c = 0.0;
        d =
          (this.cutawayValue - 0.5) * this.design.size.y + this.design.center.y;
        break;
      case "Z":
        a = 0.0;
        b = 0.0;
        c = 1.0;
        d =
          (this.cutawayValue - 0.5) * this.design.size.z + this.design.center.z;
        break;
    }

    this.viewerUI.viewer.setCutAxis(a, b, c, d);
    this.viewerUI.viewer.setLocal(true);
  };
})((window.sculpteo = window.sculpteo || {}));
